import * as React from 'react';
import { getWindowInnerWidth } from 'src_common/common/mobx-utils/Services/window';
import { observer } from 'src/utils/mobx-react';
import { Search } from 'src/domains/layouts/webview/components/search/Search';
import { RenderPopularSportsAndPromotedEvents } from './NavigationSidebar/PopularSportSection';
import { NavigationSidebarSectionSupport } from './NavigationSidebar/NavigationSidebarSectionSupport';
import { NavigationSidebarSectionAZ } from './NavigationSidebar/NavigationSidebarSectionAZ';
import { NavigationSidebarSectionCasino } from './NavigationSidebar/NavigationSidebarSectionCasino';
import { NavigationSidebarSectionRecentlyViewed } from './NavigationSidebar/NavigationSidebarSectionRecentlyViewed';
import {
    HeaderMainLinksSidebarDefault,
    MainNavigationWrapper,
    SidebarCloseIconWrapper,
    NavigationSidebarContent,
    HamburgerMenuTitle,
    SidebarSlideIconWrapper,
    SidebarSearchWrapper,
    StickyNavigationWrapper,
} from './NavigationSidebar/NavigationSidebar.style';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { CollectionType } from 'src/domains/casino/shared/Types';
import { NavigationSidebarLanguage } from './NavigationSidebar/NavigationSidebarLanguage';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

export { SidebarCloseIconWrapper, SidebarSlideIconWrapper };

const showSidebarMainLinks = (currentView: RouteViewType): React.ReactNode => {
    const widthInner = getWindowInnerWidth();
    return widthInner !== null && widthInner < 1200 ? (
        <HeaderMainLinksSidebarDefault
            languageWidth={0}
            onSidebar
            currentView={currentView}
        />
    ) : null;
};

interface CasinoNavigationSidebarPropsType {
    navigationType: CollectionType;
}

const NavigationSidebarCasino = observer(
    'NavigationSidebarCasino',
    ({ navigationType }: CasinoNavigationSidebarPropsType) => (
        <NavigationSidebarContent>
            <NavigationSidebarSectionCasino navigationType={navigationType} />
            <NavigationSidebarSectionSupport withWrapper={false} />
        </NavigationSidebarContent>
    )
);

const NavigationSidebarNonCasino = observer('NavigationSidebarNonCasino', () => {
    return (
        <NavigationSidebarContent>
            <RenderPopularSportsAndPromotedEvents />
            <NavigationSidebarSectionRecentlyViewed />
            <NavigationSidebarSectionAZ />
            <NavigationSidebarSectionSupport withWrapper={true} />
            <NavigationSidebarLanguage />
        </NavigationSidebarContent>
    );
});

interface PropsType {
    currentView: RouteViewType;
    isSearchActive: boolean;
    navigationType: CollectionType | 'global';
}

export const NavigationSidebar = observer(
    'NavigationSidebar',
    ({ currentView, isSearchActive, navigationType }: PropsType) => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        const breakpointsState = BreakpointsState.get(common);
        const appLayoutsState = AppLayoutsState.get(common);
        const { searchState } = appLayoutsState;

        const isLargeDesktop = breakpointsState.largeDesktop.isBiggerOrEq;
        const isOpen = appLayoutsState.overlay.isMenuOpen;
        const isSearchBarDesktopOpened = searchState.isShow;

        return (
            <MainNavigationWrapper isOpen={isOpen}>
                <StickyNavigationWrapper data-test='sticky-navigation-wrapper'>
                    {isSearchActive === false ? (
                        <HamburgerMenuTitle>
                            {isLargeDesktop === false ? (
                                <>
                                    Menu
                                    <SidebarCloseIconWrapper onClick={appLayoutsState.overlay.toggleMenu} />
                                </>
                            ) : null}
                        </HamburgerMenuTitle>
                    ) : (
                        <SidebarSearchWrapper
                            isSearchBarDesktopOpened={isSearchBarDesktopOpened}
                            variant={configState.componentVariants.navMenuVariant}
                        >
                            {isLargeDesktop === false ? (
                                <SidebarSlideIconWrapper
                                    position='left'
                                    onClick={searchState.handleCloseAndRedirect}
                                />
                            ) : null}
                            <Search />
                        </SidebarSearchWrapper>
                    )}
                    {showSidebarMainLinks(currentView)}
                    {navigationType === 'global' ? (
                        <NavigationSidebarNonCasino />
                    ) : (
                        <NavigationSidebarCasino navigationType={navigationType} />
                    )}
                </StickyNavigationWrapper>
            </MainNavigationWrapper>
        );
    }
);
